import { createFileRoute } from '@tanstack/react-router';

import { ClientTypesPage } from '@/features/customer-settings/ClientTypesPage';

export const Route = createFileRoute('/_app/client-types')({
    component: ClientTypesPage,
});
